<template>
  <div class="svgBox" :style="{ color: color }">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165 165" class="design-iconfont">
      <path opacity=".2"
            d="M82.5 2.49994e-06C95.8655 1.93555e-06 109.031 3.24724 120.863 9.46232C132.696 15.6774 142.841 24.6742 150.427 35.6787C158.012 46.6832 162.81 59.3658 164.408 72.6354C166.006 85.905 164.356 99.3642 159.601 111.855C154.845 124.346 147.126 135.494 137.107 144.341C127.089 153.187 115.071 159.468 102.088 162.641C89.1043 165.814 75.5444 165.786 62.5746 162.558C49.6048 159.33 37.6135 152.999 27.6323 144.11L41.3492 128.707C48.8351 135.374 57.8286 140.122 67.556 142.543C77.2833 144.964 87.4532 144.986 97.1907 142.606C106.928 140.226 115.942 135.516 123.456 128.881C130.969 122.246 136.759 113.884 140.326 104.516C143.892 95.1481 145.13 85.0538 143.931 75.1016C142.732 65.1494 139.134 55.6374 133.445 47.384C127.756 39.1307 120.147 32.383 111.273 27.7217C102.398 23.0604 92.5241 20.625 82.5 20.625L82.5 2.49994e-06Z"
            fill="currentColor"/>
      <path opacity=".1"
            d="M25.776 142.405C13.9279 131.186 5.67263 116.706 2.05417 100.795C-1.56428 84.8846 -0.383409 68.2582 5.44746 53.0186C11.2783 37.7791 21.4973 24.6108 34.8121 15.179C48.127 5.74725 63.9396 0.475586 80.2505 0.0306764L80.8129 20.648C68.5797 20.9817 56.7202 24.9354 46.7341 32.0093C36.748 39.0831 29.0837 48.9593 24.7106 60.389C20.3374 71.8186 19.4518 84.2884 22.1656 96.2214C24.8795 108.154 31.0709 119.015 39.957 127.429L25.776 142.405Z"
            fill="currentColor" fill-opacity=".5"/>
    </svg>
    <div class="no-data-text">当前无数据</div>
  </div>

</template>
<script>
export default {
  name: "noDataSvg",
  props: {
    color: {
      type: String,
      default: '#787A80',
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.svgBox {
  width: 100%;
  height: 94%;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }

  .no-data-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 0.7;
  }
}
</style>
